const isDeliveredNationalwide = tags => {
  if (!tags) return true;

  const noShowTag = 'noshow:';
  const regularExpresion = new RegExp(noShowTag);
  const containsNoShowTag = String(tags).match(regularExpresion);

  return !containsNoShowTag;
};

export default isDeliveredNationalwide;
